import type { EntitiesState } from '@redux/entities'
import { AddressModel, AgencyModel } from '@models/types'

export const splitAddress = (address?: string) => (address ? address.split('\n') : [])

type FormatShippingAddressParams = {
  addressId: number | string | 'physical_address',
  agency: AgencyModel,
  addresses: EntitiesState['addresses'],
}

export function formatShippingAddress(params: FormatShippingAddressParams) {
  const { addressId, addresses, agency } = params

  if (addressId === 'physical_address'){
    const {
      address_line_1,
      address_line_2,
      address_postcode,
      address_region,
      address_state,
      title,
    } = agency

    let formattedAddress = `${title}\n${address_line_1}\n`
    formattedAddress += address_line_2 ? `${address_line_2}\n` : ''
    formattedAddress += `${address_region} ${address_state} ${address_postcode}`

    return formattedAddress
  }

  const address = addresses[addressId] || {}
  if (address.id){
    const {
      address_line_1,
      address_line_2,
      address_postcode,
      address_region,
      address_state,
      title,
    } = address

    let formattedAddress = `${title}\n${address_line_1}\n`
    formattedAddress += address_line_2 ? `${address_line_2}\n` : ''
    formattedAddress += `${address_region} ${address_state} ${address_postcode}`

    return formattedAddress
  }

  return ''
}

type OptionsParams = {
  localAddress?: boolean,
  multiLine?: boolean,
  title?: string,
}

export function getFullAddress(address: Partial<AddressModel>, options: OptionsParams = {}) {
  if (!address) return ''

  const {
    address_line_1, address_line_2, address_postcode, address_region, address_state,
  } = address

  const { localAddress = false, multiLine = false } = options

  if (!address_line_1 && !address_line_2) return ''

  const street = address_line_2 ? `${address_line_1}, ${address_line_2}` : address_line_1

  if (multiLine){
    let formattedAddress = `${address_line_1}\n`
    formattedAddress += address_line_2 ? `${address_line_2}\n` : ''
    formattedAddress += `${address_region} ${address_state} ${address_postcode}`

    return formattedAddress
  }

  if (localAddress) return `${street}, ${address_region}`

  return `${street}, ${address_region} ${address_postcode} ${address_state}`
}

export default getFullAddress
